import React from 'react';

import { withAuthentication } from '../authentication';
import {
  Sources,
  Users,
  Settings,
  OrganizationManagement,
  DataWarehouse,
  QuestionReview,
  BusinessLogic
} from './pages';
import {
  LinkTokenProvider,
  SourcesProvider,
  IntegrationsProvider,
  QuestionReviewProvider
} from './providers';
import {
  SpacesProvider,
  ConversationsProvider,
  DatabaseDescriptionProvider,
  TermTranslationsProvider
} from '../chats/providers';

const organizationRouter = () => ({
  path: 'organization/*',
  element: withAuthentication(() => (
    <SpacesProvider>
      <ConversationsProvider type='asset'>
        <TermTranslationsProvider>
          <OrganizationManagement />
        </TermTranslationsProvider>
      </ConversationsProvider>
    </SpacesProvider>
  )),
  children: [
    {
      path: 'people',
      element: <Users />
    },
    {
      path: 'sources',
      element: (
        <LinkTokenProvider>
          <SourcesProvider>
            <IntegrationsProvider>
              <Sources />
            </IntegrationsProvider>
          </SourcesProvider>
        </LinkTokenProvider>
      )
    },
    {
      path: 'settings',
      element: <Settings />
    },
    {
      path: 'data-warehouse',
      element: (
        <SourcesProvider>
          <DatabaseDescriptionProvider>
            <DataWarehouse />
          </DatabaseDescriptionProvider>
        </SourcesProvider>
      )
    },
    {
      path: 'business-logic',
      element: <BusinessLogic />
    },
    {
      path: 'question-review',
      element: (
        <QuestionReviewProvider>
          <QuestionReview />
        </QuestionReviewProvider>
      )
    }
  ]
});

export { organizationRouter };
